export default __webpack_public_path__ + "static/media/gestaoplanejamento.c5c0ee71.svg";